export default class Accordion {
    constructor() {
        this.accordionToggles = [...document.getElementsByClassName('js-accordion-toggle')];

        if (!this.accordionToggles) {
            return;
        }

        this.accordionToggles.forEach(accordionToggle => {
            accordionToggle.addEventListener('click', () => {
                // FIXME: Make this more independent from markup structure
                const accordionContent = accordionToggle.parentElement.parentElement;

                if (!accordionContent.classList.contains('js-content-visible')) {
                    this.foldAdd();
                    accordionContent.classList.remove('js-hide-content');
                    accordionContent.classList.add('js-content-visible');
                } else {
                    this.foldAdd();
                }
            })
        });
    }

    foldAdd() {
        this.accordionToggles.forEach(accordionToggle => {
            accordionToggle.parentElement.parentElement.classList.add('js-hide-content');
            accordionToggle.parentElement.parentElement.classList.remove('js-content-visible');
        });
    }
}